class NyvoltNavigation extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.controller = new AbortController();
    const options = {signal:this.controller.signal};
    this.dialog = this.querySelector('[data-nv-drawer]');
    this.heading = this.querySelector('[data-nv-menu-title]');
    this.back = this.querySelector('[data-nv-menu-back]');
    this.mega = this.querySelector('[data-nv-mega]');
    this.desktop = window.matchMedia('(min-width:1101px)');
    this.finePointer = window.matchMedia('(hover:hover) and (pointer:fine)');
    this.openers = Array.from(this.querySelectorAll('[data-nv-menu-open]'));
    const syncMode = () => {
      this.closeMega(false);
      if (this.dialog.open) this.dialog.close();
      this.openers.forEach(button => {
        button.setAttribute('aria-controls', this.desktop.matches ? this.mega.id : this.dialog.id);
        if (this.desktop.matches) button.removeAttribute('aria-haspopup');
        else button.setAttribute('aria-haspopup','dialog');
      });
    };
    this.desktop.addEventListener('change',syncMode,options);
    syncMode();
    this.addEventListener('click', event => {
      const open = event.target.closest('[data-nv-menu-open]');
      const panel = event.target.closest('[data-nv-panel-open]');
      if (open) {
        if (this.desktop.matches) {
          // A click after a hover keeps the menu open; a second deliberate click closes it.
          if (!this.mega.hidden && this.opener === open && this.openedByClick) this.closeMega(false);
          else { this.openMega(open); this.openedByClick = true; }
        } else {
          this.opener = open;
          this.showPanel(open.dataset.nvMenuOpen || 'root', false);
          this.dialog.showModal();
          open.setAttribute('aria-expanded','true');
          document.documentElement.classList.add('nv-menu-is-open');
        }
      } else if (event.target.closest('[data-nv-mega-close]')) {
        this.closeMega(true);
      } else if (panel) {
        this.panelTrigger = panel;
        this.showPanel(panel.dataset.nvPanelOpen,true);
      } else if (event.target.closest('[data-nv-menu-back]')) {
        this.showPanel('root',false);
        (this.panelTrigger || this.querySelector('[data-nv-panel-open]'))?.focus();
      } else if (event.target.closest('[data-nv-menu-close]')) {
        this.dialog.close();
      } else if (event.target.closest('a')) {
        if (this.dialog.open) this.dialog.close();
        this.closeMega(false);
      } else if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }
    },options);
    this.openers.forEach(button => button.addEventListener('pointerenter', event => {
      if (this.desktop.matches && this.finePointer.matches && event.pointerType !== 'touch') {
        clearTimeout(this.closeTimer);
        this.openedByClick = false;
        this.openMega(button);
      }
    },options));
    this.addEventListener('pointerenter',()=>clearTimeout(this.closeTimer),options);
    this.addEventListener('pointerleave',()=>{
      if (this.desktop.matches && this.finePointer.matches) {
        this.closeTimer = setTimeout(()=>{
          if (!this.mega.contains(document.activeElement)) this.closeMega(false);
        },220);
      }
    },options);
    this.addEventListener('focusout',()=>{
      queueMicrotask(()=>{ if (!this.contains(document.activeElement)) this.closeMega(false); });
    },options);
    this.addEventListener('keydown',event=>{
      if (!this.desktop.matches || this.mega.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); this.closeMega(true); }
      else if ((event.key === 'Tab' && !event.shiftKey || event.key === 'ArrowDown') && event.target === this.opener) {
        event.preventDefault();
        this.mega.querySelector('[data-nv-mega-family]:not([hidden]) a')?.focus();
      } else if (event.key === 'Tab' && event.shiftKey && event.target === this.mega.querySelector('[data-nv-mega-family]:not([hidden]) a')) {
        event.preventDefault();this.opener?.focus();
      }
    },options);
    document.addEventListener('pointerdown',event=>{
      if (!this.contains(event.target)) this.closeMega(false);
    },options);
    this.dialog.addEventListener('close',()=>{
      document.documentElement.classList.remove('nv-menu-is-open');
      this.openers.forEach(button=>button.setAttribute('aria-expanded','false'));
      this.opener?.focus();
    },options);
  }
  openMega(button) {
    clearTimeout(this.closeTimer);
    const family = button.dataset.nvMenuOpen || 'root';
    this.opener = button;
    this.mega.querySelectorAll('[data-nv-mega-family]').forEach(item=>{
      item.hidden = family === 'surron' ? !['ultra','light','hyper'].includes(item.dataset.nvMegaFamily) : family !== 'root' && item.dataset.nvMegaFamily !== family;
    });
    const title = this.mega.querySelector('[data-nv-mega-title]');
    title.textContent = family === 'root' ? title.dataset.defaultTitle : {surron:'Sur-Ron',ultra:'Ultra Bee',light:'Light Bee',hyper:'Hyper Bee',talaria:'Talaria','79bike':'79Bike'}[family] || button.textContent.trim();
    this.mega.querySelector('.nv-mega-grid')?.setAttribute('aria-label', title.textContent);
    this.mega.hidden = false;
    this.openers.forEach(opener=>opener.setAttribute('aria-expanded',String(opener===button)));
  }
  closeMega(focus) {
    clearTimeout(this.closeTimer);
    if (!this.mega || this.mega.hidden) return;
    this.mega.hidden = true;
    this.openedByClick = false;
    this.openers.forEach(button=>button.setAttribute('aria-expanded','false'));
    if (focus) this.opener?.focus();
  }
  showPanel(id, focus) {
    const panels = Array.from(this.querySelectorAll('[data-nv-panel]'));
    const active = panels.find(panel=>panel.dataset.nvPanel===id) || panels[0];
    panels.forEach(panel=>{panel.hidden=panel!==active;});
    this.heading.textContent = active.dataset.nvTitle;
    this.back.hidden = active.dataset.nvPanel === 'root';
    this.dialog.dataset.currentPanel = active.dataset.nvPanel;
    active.scrollTop = 0;
    if (focus) this.heading.focus();
  }
  disconnectedCallback() {
    this.controller?.abort();
    clearTimeout(this.closeTimer);
    if (this.dialog?.open) this.dialog.close();
    document.documentElement.classList.remove('nv-menu-is-open');
    this.ready = false;
  }
}
if (!customElements.get('nyvolt-navigation')) customElements.define('nyvolt-navigation', NyvoltNavigation);
function revealNyvoltComparison() {
  if (window.location.hash === '#comparer') {
    const comparison = document.getElementById('comparer');
    if (comparison instanceof HTMLDetailsElement) comparison.open = true;
  }
}
revealNyvoltComparison();
window.addEventListener('hashchange', revealNyvoltComparison);
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const target = new URL(link.href, window.location.href);
  if (target.origin === window.location.origin && target.pathname === window.location.pathname && target.hash === '#comparer') {
    const comparison = document.getElementById('comparer');
    if (comparison instanceof HTMLDetailsElement) comparison.open = true;
  }
});

